package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.styleModifier
import io.horion.cv.api.datasource.cv.Section
import io.horion.cv.components.cards.GenericFormCard
import io.horion.cv.components.cards.SummaryData
import io.horion.cv.components.widgets.AddButton
import io.horion.cv.models.PersonalizedSectionType
import io.horion.cv.models.RubriqueCompetenceState
import io.horion.cv.viewModel.CvViewModel
import org.jetbrains.compose.web.css.px

@Composable
fun RubriqueCompetenceAccordionContent(
    sectionId: String,
    cvViewModel: CvViewModel,
    onComplete: (String) -> Unit,
    onAddCompetenceAndClose: (String) -> Unit,
) {
    var competences by remember {
        mutableStateOf(
            listOf(
                RubriqueCompetenceState(
                    id = "rubrique-competence-1",
                    sectionId = sectionId
                )
            )
        )
    }

    var editingCompetenceId by remember { mutableStateOf<String?>("rubrique-competence-1") }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .styleModifier {
                property("box-sizing", "border-box")
                property("min-width", "0")
            },
        verticalArrangement = Arrangement.spacedBy(30.px)
    ) {
        competences.forEach { competence ->
            GenericFormCard(
                item = competence,
                isEditing = editingCompetenceId == competence.id,
                onEdit = { editingCompetenceId = competence.id },
                onDelete = {
                    competences = competences.filterNot { it.id == competence.id }
                    if (competences.isEmpty()) {
                        competences = listOf(RubriqueCompetenceState(id = "rubrique-competence-1", sectionId = sectionId))
                        editingCompetenceId = "rubrique-competence-1"
                    }
                },
                onComplete = {
                    cvViewModel.updatePersonalizedSection(
                        sectionId = competence.id
                    ) { section ->
                        section.copy(
                            title = competence.competence,
                            resume = competence.niveauLabel
                        )
                    }

                    editingCompetenceId = null
                },
                getSummary = { c ->
                    if (c.competence.isNotBlank() || c.niveau > 0) {
                        SummaryData(
                            title = c.competence.ifBlank { "[Compétence]" },
                            subtitle = c.niveauLabel.takeIf { c.niveau > 0 } ?: "[Niveau]"
                        )
                    } else {
                        null
                    }
                },
                getDefaultText = { "[Compétence]" },
                formContent = { state, onDel, onComp ->
                    RubriqueCompetenceForm(
                        state = state,
                        onDelete = onDel,
                        onComplete = onComp,
                    )
                }
            )
        }
        AddButton(
            text = "Ajouter un élément",
            onClick = {
                editingCompetenceId = null
                val newCompetence = RubriqueCompetenceState(
                    id = "$sectionId-competence-${competences.size + 1}",
                    sectionId = sectionId
                )

                cvViewModel.addPersonalizedSection(
                    Section(
                        id = newCompetence.id,
                        type = PersonalizedSectionType.COMPETENCES
                    )
                )

                competences = competences + newCompetence
            }
        )
    }
}